import React from 'react';
import { motion } from 'framer-motion';
export function ComparisonTable() {
  return <section className="py-16 md:py-24 bg-cream" data-id="element-69">
      <div className="max-w-4xl mx-auto px-4" data-id="element-70">
        <h2 className="text-2xl md:text-3xl font-heading font-semibold text-center text-charcoal mb-12" data-id="element-71">
          Wie Luisé sich zu dem verhält, was du schon probiert hast
        </h2>

        <div className="overflow-x-auto pb-4" data-id="element-72">
          <motion.table initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} className="w-full min-w-[600px] border-collapse bg-white shadow-sm rounded-lg overflow-hidden" data-id="element-73">
            <thead data-id="element-74">
              <tr className="border-b border-charcoal/10" data-id="element-75">
                <th className="p-4 text-left w-1/4" data-id="element-76"></th>
                <th className="p-4 text-center font-ui text-sm font-semibold text-charcoal/60 uppercase tracking-wider w-[18%]" data-id="element-77">
                  Rosmarin/ Castoröl DIY
                </th>
                <th className="p-4 text-center font-ui text-sm font-semibold text-charcoal/60 uppercase tracking-wider w-[18%]" data-id="element-78">
                  Nahrungsergänzung
                </th>
                <th className="p-4 text-center font-ui text-sm font-semibold text-charcoal/60 uppercase tracking-wider w-[18%]" data-id="element-79">
                  Minoxidil
                </th>
                <th className="p-4 text-center font-ui text-base font-bold text-charcoal uppercase tracking-wider bg-accent-light/30 border-b-2 border-accent w-[21%]" data-id="element-80">
                  Luisé
                </th>
              </tr>
            </thead>
            <tbody className="font-ui text-sm" data-id="element-81">
              <tr className="border-b border-charcoal/5" data-id="element-82">
                <td className="p-4 font-semibold text-charcoal" data-id="element-83">
                  Fettfreie Anwendung?
                </td>
                <td className="p-4 text-center text-charcoal/70" data-id="element-84">Nein</td>
                <td className="p-4 text-center text-charcoal/70" data-id="element-85">
                  Nicht relevant
                </td>
                <td className="p-4 text-center text-charcoal/70" data-id="element-86">
                  Oft reizend
                </td>
                <td className="p-4 text-center font-semibold text-charcoal bg-accent-light/30" data-id="element-87">
                  Ja
                </td>
              </tr>
              <tr className="border-b border-charcoal/5" data-id="element-88">
                <td className="p-4 font-semibold text-charcoal" data-id="element-89">
                  Erste Veränderungen
                </td>
                <td className="p-4 text-center text-charcoal/70" data-id="element-90">3–6 Monate</td>
                <td className="p-4 text-center text-charcoal/70" data-id="element-91">3–6 Monate</td>
                <td className="p-4 text-center text-charcoal/70" data-id="element-92">Variiert</td>
                <td className="p-4 text-center font-semibold text-charcoal bg-accent-light/30" data-id="element-93">
                  2–4 Wochen (Gefühl),
                  <br data-id="element-94" />
                  länger (sichtbar)
                </td>
              </tr>
              <tr className="border-b border-charcoal/5" data-id="element-95">
                <td className="p-4 font-semibold text-charcoal" data-id="element-96">
                  Einfach beizubehalten?
                </td>
                <td className="p-4 text-center text-charcoal/70" data-id="element-97">Schwer</td>
                <td className="p-4 text-center text-charcoal/70" data-id="element-98">Einfach</td>
                <td className="p-4 text-center text-charcoal/70" data-id="element-99">Schwer</td>
                <td className="p-4 text-center font-semibold text-charcoal bg-accent-light/30" data-id="element-100">
                  Ja
                </td>
              </tr>
              <tr className="border-b border-charcoal/5" data-id="element-101">
                <td className="p-4 font-semibold text-charcoal" data-id="element-102">
                  Direkt auf die Kopfhaut?
                </td>
                <td className="p-4 text-center text-charcoal/70" data-id="element-103">Manchmal</td>
                <td className="p-4 text-center text-charcoal/70" data-id="element-104">Nein</td>
                <td className="p-4 text-center text-charcoal/70" data-id="element-105">Ja</td>
                <td className="p-4 text-center font-semibold text-charcoal bg-accent-light/30" data-id="element-106">
                  Ja
                </td>
              </tr>
              <tr data-id="element-107">
                <td className="p-4 font-semibold text-charcoal" data-id="element-108">
                  Beauty-freundlich?
                </td>
                <td className="p-4 text-center text-charcoal/70" data-id="element-109">Selten</td>
                <td className="p-4 text-center text-charcoal/70" data-id="element-110">Ja</td>
                <td className="p-4 text-center text-charcoal/70" data-id="element-111">Nein</td>
                <td className="p-4 text-center font-semibold text-charcoal bg-accent-light/30" data-id="element-112">
                  Ja
                </td>
              </tr>
            </tbody>
          </motion.table>
        </div>
      </div>
    </section>;
}